import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "@tsp-core/store/utils";

import { AccrualModelUnitName } from "../enums";
import { AccrualModelId, AccrualModelsDictionary } from "../types";

type GetAccrualModelsResponseData = {
  items: Array<{
    id: AccrualModelId;
    unitName: AccrualModelUnitName;
    description: string | null;
    defaultQuantityDivider: number;
    isDisabled: boolean;
    isDeprecated: boolean;
    isLegacy: boolean;
  }>;
};

export const accrualModelsApi = createApi({
  reducerPath: "@accrual-models/api",
  baseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  refetchOnMountOrArgChange: false,
  keepUnusedDataFor: 60 * 60 * 24,
  tagTypes: ["AccrualModelsDictionary"],
  endpoints: (builder) => ({
    getAccrualModelsDictionary: builder.query<AccrualModelsDictionary, void>({
      query: () => ({
        url: "/getAccrualModels",
        method: "POST",
      }),
      providesTags: ["AccrualModelsDictionary"],
      transformResponse: (response: GetAccrualModelsResponseData) => {
        return response.items.reduce((accumulator, item) => {
          const name = `${item.id} (unit: ${item.unitName})`;
          const postfix = item.isDisabled || item.isDisabled ? " (Archived)" : "";

          accumulator[item.id] = {
            id: item.id,
            unitName: item.unitName,
            name: `${name}${postfix}`,
            defaultQuantityDivider: item.defaultQuantityDivider,
            description: item.description || "",
            isDeprecated: item.isDeprecated,
            isDisabled: item.isDisabled,
            isLegacy: item.isLegacy,
          };
          return accumulator;
        }, {} as AccrualModelsDictionary);
      },
    }),
  }),
});
